// Ссылка на сущность. Один компонент на все разделы — адрес собирается в lib/entities.
//
// Название НЕ загружается само: в списке из пятидесяти строк это дало бы пятьдесят
// запросов. Правило простое — в списках название уже пришло вместе с данными, передавайте
// его в title; для одиночного места (карточка показывает свою компанию) есть resolve.
import { Link } from 'react-router-dom'

import { useEntityTitle } from '../api/hooks'
import { entityPath } from '../lib/entities'
import type { EntityKind } from '../lib/entities'
import { refId } from '../lib/smart'

interface Props {
  kind: EntityKind
  id: string | number | null | undefined
  /** Название, если оно уже есть. Без него покажется #id. */
  title?: string | null
  /** Догрузить название по id. ТОЛЬКО для одиночных мест, не для списков. */
  resolve?: boolean
  /** Что показать, когда ссылки нет вовсе. */
  empty?: string
  className?: string
}

export function EntityLink({ kind, id, title, resolve = false, empty = '—', className }: Props) {
  /**
   * «Привязки нет» Bitrix пишет НУЛЁМ, а не пустотой, и `!id` этого не ловит: строка '0'
   * правдива. Из-за этого рисовалась ссылка «#0» на /companies/0 — адрес, за которым ничего
   * нет: карточка уходила в ядро, получала «не найдено» и показывала ошибку там, где
   * правильный ответ — «не привязано».
   *
   * Чистка стоит внутри самого компонента, а не у каждого вызывающего: мест вызова около
   * тридцати, и «забыли почистить в одном» — это ровно то, что уже произошло. Функция та же
   * самая (refId из lib/smart.ts), второй такой нет.
   */
  const ref = refId(id)
  // Догружаем только если название не передали и явно попросили — иначе лишний запрос.
  const needFetch = resolve && !title && !!ref
  const q = useEntityTitle(kind, needFetch ? ref : undefined)

  if (!ref) return <span className="muted">{empty}</span>

  const shown = title || q.data || `#${ref}`
  return (
    <Link to={entityPath(kind, ref)} className={className} title={shown}>
      {shown}
    </Link>
  )
}
